import { OrderBookingFormPresentation } from './order-booking-form-presentation';
import { OrderBookingFormVM } from './order-booking-form.viewmodel';
import { withViewModel } from '../../../infrastructure/components/with-view-model';

interface IProps {
    vm: OrderBookingFormVM;
}

const OrderBookingFormContainer = withViewModel(
    OrderBookingFormPresentation,
    (props: IProps) => {
        return props.vm;
    },
    () => []
);

export { OrderBookingFormContainer as OrderBookingForm };
